import * as angular from 'angular';

import { IRequestService } from '../../services';
import { Unit } from '../../models';

export interface IUnitService {
    getAll(): angular.IPromise<Unit[]>;
    getByGuid(guid: string): angular.IPromise<Unit>;
}

export class UnitService implements IUnitService {
    static serviceId = 'unitService';

    static $inject = ['requestService'];

    constructor(private _requestService: IRequestService) {
    }

    getAll(): angular.IPromise<Unit[]> {
        const url = this._requestService.getUrlV1() + 'unit';
        return this._requestService.get(url);
    }

    getByGuid(guid: string): angular.IPromise<Unit> {
        const url = this._requestService.getUrlV1() + 'unit/' + guid;
        return this._requestService.get(url);
    }
}

